<template>
  <div class="mb-4">
    <label :for="setting.name">
      {{ setting.label }}
    </label>

    <SettingsMessage v-if="setting.message" :message="setting.message" />

    <UiCheckbox
      v-model="setting.booleanValue"
      :name="setting.name"
      :disabled="saving"
      @change="onChange"
    />
  </div>
</template>

<script>
import clone from "just-clone";
import SettingsMessage from "./SettingsMessage";
import UiCheckbox from "@/components/UI/UiCheckbox";

export default {
  name: "BooleanSetting",
  components: { SettingsMessage, UiCheckbox },
  props: {
    setting: {
      type: Object,
      required: true,
      booleanValue: {
        default: false,
        type: Boolean,
      },
      id: {
        required: true,
        type: String,
      },
      label: {
        default: "",
        type: String,
      },
    },
    saving: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    onChange(event) {
      const setting = clone(this.setting);
      setting.booleanValue = event;
      this.$emit("setting-updated", setting, event);
    },
  },
};
</script>
